// extracted by mini-css-extract-plugin
export default {"input":"Tda-z","button":"Uda-z","selected":"Vda-z","unavailable":"Wda-z","oos":"Xda-z","paperCutDisabledOverlay":"Yda-z","image":"Zda-z"};